import {commentAxios} from "../commentAxios";

export const createComment = (payload) => {
    return commentAxios.post('/comments', payload);
};
